(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4144],{

/***/ 8518:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/wordpress-integration",
      function () {
        return __webpack_require__(23959);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93179);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89583);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51649);
/* harmony import */ var utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5847);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);









const WordpressIntegration = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-screen-xl mx-auto mb-10 md:mt-20 mt-8 md:px-8 px-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Wordpress Integration | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Electronic signatures refer to signatures in digital format, distinguishing them from traditional handwritten signatures. These digital signatures hold full legal validity for indicating consent or endorsement of document contents. The prevalence of eSignatures is progressively supplanting manual signatures, serving as a versatile method to sign a wide array of documents spanning various sectors on a global scale."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "eSignature, electronic signature, digital signature, eSign, eSignatures, electronic signatures, digital signatures, eSignature software, electronic signature software, digital signature software, eSignature solution, electronic signature solution, digital signature solution, eSignature app, electronic signature app, digital signature app, eSignature platform, electronic signature platform, digital signature platform, eSignature service, electronic signature service, digital signature service, eSignature tool, electronic signature tool, digital signature tool, eSignature online, electronic signature online, digital signature online, eSignature solution online, electronic signature solution online, digital signature solution online, eSignature software online, electronic signature software online, digital signature software online, eSignature platform online, electronic signature platform online, digital signature platform online"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/wordpress-integration/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Wordpress Integration | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/wordpress-integration/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Wordpress Integration | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/wordpress-integration/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaWordpress */ .k7O, {
                            className: "text-8xl mx-auto"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "mt-5 text-center text-4xl font-bold sm:text-6xl",
                            children: [
                                "Document Signing for ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[#21759b]",
                                    children: "Wordpress"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "mt-10 mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-lg sm:text-xl",
                        children: "WordPress stands as one of the most popular platforms for website creation. This versatile platform simplifies the process of building websites, adding content, and enhancing functionality with a variety of plugins. However, if your website needs to handle PDF document signings, BoloSign can be a game-changer. In just a few steps, you can integrate the capability to sign PDF documents directly on your site. This feature is incredibly useful for businesses that operate online or websites offering online services, streamlining processes and improving user experience."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl sm:text-4xl mt-0 mb-6",
                                children: "How to Sign PDF in Wordpress"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "text-lg sm:text-xl leading-9 sm:leading-10 list-disc pl-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                className: "underline",
                                                href: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                                    from: "WEBSITE_BOTTOM_BUTTON"
                                                })),
                                                target: "_blank",
                                                children: "Sign up"
                                            }),
                                            " ",
                                            "for a free BoloSign account and upload the PDF document you need signed."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Open your uploaded PDF in the BoloSign editor and insert the necessary fields for signatures and any other required information."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Copy the embed code provided by BoloSign and embed it on your website at the desired location."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Start receiving signed copies of your PDF documents directly in your BoloSign account and via email."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-10 space-y-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "flex items-center space-x-2 text-xl sm:text-3xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_7__/* .IoIosArrowDropright */ .kWz, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "PDF Template Creation"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "Before diving in, start by",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        className: "underline",
                                        href: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                            from: "WEBSITE_BOTTOM_BUTTON"
                                        })),
                                        target: "_blank",
                                        children: "creating a free account"
                                    }),
                                    " ",
                                    "on our website and prepare the document you will use as a basis for your template."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "On the PDF Templates page of BoloSign, click the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Create Template"'
                                    }),
                                    " button located in the top right corner. In the next page that appears, upload PDF and add roles. Choose these roles carefully, as they will be used to assign fields to the appropriate signers."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg sm:text-xl",
                                children: "In the center of the editor page, you'll find a section where you can either drag and drop your document or click to select a file from your computer. Once the document is uploaded, it will appear on the screen, ready for you to start adding fields. You'll find all the possible fields you can add in the right-hand panel. Feel free to experiment with the placement and sizes of these fields to ensure the document looks exactly as you want it to. And remember, there's no need to worry - you can always modify the template after it's been created, so you have the flexibility to adjust things as needed."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "After adding all the necessary fields and ensuring the document looks exactly as you want, click the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Get Invite Link"'
                                    }),
                                    " button. Your document will be saved in your account and you will get a link to invite signer to sign this document. You can use this link to create a iframe and embed it on your website."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    language: "html",
                                    style: utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_4__/* .a11yDark */ .V,
                                    children: '<iframe src="your_pdf_template_link" width= 200px" height=700px" name="BoloForms"></iframe>'
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "md:h-[640px] h-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                    src: "https://app.tango.us/app/embed/ce399adf-305b-42be-a9c1-03281b96ce01?skipCover=false&defaultListView=false&skipBranding=true",
                                    style: {
                                        minHeight: "400px"
                                    },
                                    sandbox: "allow-scripts allow-top-navigation-by-user-activation allow-popups allow-same-origin",
                                    security: "restricted",
                                    title: "How to Create Pdf Templates and Get Html code to Embed using IFrame",
                                    width: "100%",
                                    height: "100%",
                                    referrerpolicy: "strict-origin-when-cross-origin",
                                    frameborder: "0",
                                    webkitallowfullscreen: "webkitallowfullscreen",
                                    mozallowfullscreen: "mozallowfullscreen",
                                    allowfullscreen: "allowfullscreen"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-10 space-y-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "flex items-center space-x-2 text-xl sm:text-3xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_7__/* .IoIosArrowDropright */ .kWz, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Form Creation"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "Make sure you have",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        className: "underline",
                                        href: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                            from: "WEBSITE_BOTTOM_BUTTON"
                                        })),
                                        target: "_blank",
                                        children: "created a free account"
                                    }),
                                    " ",
                                    "on our website and prepare the document you will use as a basis for your form."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "On the Forms page of BoloSign, click the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Create Form"'
                                    }),
                                    " button located in the top right corner. In the next page that appears, you will have to add fields in the form. You can add text fields, signature fields, date fields, etc."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "Click on the ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Customize PDF"'
                                    }),
                                    " ",
                                    "button on top right corner to upload your PDF document. Click on continue button to map fields in the PDF document."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg sm:text-xl",
                                children: "In the right of the editor page, you'll find a section where you can click to select fields to add in the form. Feel free to experiment with the placement and sizes of these fields to ensure the document looks exactly as you want it to. And remember, there's no need to worry - you can always modify the template after it's been created, so you have the flexibility to adjust things as needed."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "After adding all the necessary fields and ensuring the document looks exactly as you want, go back to the form editor by clicking on the form button top left of the screen. Here click the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Send"'
                                    }),
                                    " button. Now in the popup that appears, click on the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"< >"'
                                    }),
                                    " button. You will get a code to embed the form on your website."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    language: "html",
                                    style: utils_react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_4__/* .a11yDark */ .V,
                                    children: '<iframe src="your_form_link" width= 200px" height=700px" name="BoloForms"></iframe>'
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                    src: "https://app.tango.us/app/embed/f0336757-8f9d-474d-8850-6b51b635a2fb?skipCover=false&defaultListView=false&skipBranding=true",
                                    style: {
                                        minHeight: "400px"
                                    },
                                    sandbox: "allow-scripts allow-top-navigation-by-user-activation allow-popups allow-same-origin",
                                    security: "restricted",
                                    title: "How to Create Form and Get Html Code to Embed",
                                    width: "100%",
                                    height: "100%",
                                    referrerpolicy: "strict-origin-when-cross-origin",
                                    frameborder: "0",
                                    webkitallowfullscreen: "webkitallowfullscreen",
                                    mozallowfullscreen: "mozallowfullscreen",
                                    allowfullscreen: "allowfullscreen"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-10 space-y-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "flex space-x-2 text-xl sm:text-3xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_7__/* .IoIosArrowDropright */ .kWz, {
                                        className: "mt-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Adding the Embed HTML Code to a WordPress Page"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg sm:text-xl",
                                children: "You can insert the signing form for your document template on any page of your website. Whether it's a contact page or a dedicated document signing page, the process is straightforward."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "To embed the signing form, navigate to the admin panel of your WordPress website. Then, select the page where you want to place the signing form and click on",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Edit"'
                                    }),
                                    ". Decide where on the page you'd like the form to appear and click on the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"+"'
                                    }),
                                    " button (Add block). In the search field, type",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Custom HTML"'
                                    }),
                                    " if you're using the English version of WordPress, or the equivalent translation for other languages. In the block that appears, paste the HTML code you prepared earlier into the input field."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-lg sm:text-xl",
                                children: [
                                    "After you've pasted the HTML code, click on the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-bold",
                                        children: '"Preview"'
                                    }),
                                    " button to see how the form will look on your website and then save the changes to the page. Now, the document signing form will be available on your website, allowing users to easily sign documents directly on your site."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-xl sm:text-3xl",
                                children: "Conclusions"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-5 text-lg sm:text-xl",
                                children: "In this guide, we've only scratched the surface of what's possible with BoloSign within a WordPress application. BoloSign offers various eSignature features that you can utilize to enhance your application. You have the ability to customize the signing form on your website to a great extent using various parameters, ensuring that it perfectly aligns with your site's style and functional needs. Importantly, leveraging these advanced features doesn't require the installation of additional plugins or extensions. Everything operates smoothly with WordPress's basic capabilities, making it a straightforward and efficient way to elevate your website's functionality and user experience."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WordpressIntegration);


/***/ }),

/***/ 5847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ a11yDark; }
/* harmony export */ });
const a11yDark = {
    'code[class*="language-"]': {
        color: "#f8f8f2",
        background: "none",
        fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        wordWrap: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none"
    },
    'pre[class*="language-"]': {
        color: "#f8f8f2",
        background: "#2b2b2b",
        fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        wordWrap: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none",
        padding: "1em",
        overflow: "auto",
        borderRadius: "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
        background: "#2b2b2b",
        padding: "0.1em",
        borderRadius: "0.3em",
        whiteSpace: "normal"
    },
    comment: {
        color: "#d4d0ab"
    },
    prolog: {
        color: "#d4d0ab"
    },
    doctype: {
        color: "#d4d0ab"
    },
    cdata: {
        color: "#d4d0ab"
    },
    punctuation: {
        color: "#fefefe"
    },
    property: {
        color: "#ffa07a"
    },
    tag: {
        color: "#ffa07a"
    },
    constant: {
        color: "#ffa07a"
    },
    symbol: {
        color: "#ffa07a"
    },
    deleted: {
        color: "#ffa07a"
    },
    boolean: {
        color: "#00e0e0"
    },
    number: {
        color: "#00e0e0"
    },
    selector: {
        color: "#abe338"
    },
    "attr-name": {
        color: "#abe338"
    },
    string: {
        color: "#abe338"
    },
    char: {
        color: "#abe338"
    },
    builtin: {
        color: "#abe338"
    },
    inserted: {
        color: "#abe338"
    },
    operator: {
        color: "#00e0e0"
    },
    entity: {
        color: "#00e0e0",
        cursor: "help"
    },
    url: {
        color: "#00e0e0"
    },
    ".language-css .token.string": {
        color: "#00e0e0"
    },
    ".style .token.string": {
        color: "#00e0e0"
    },
    variable: {
        color: "#00e0e0"
    },
    atrule: {
        color: "#ffd700"
    },
    "attr-value": {
        color: "#ffd700"
    },
    function: {
        color: "#ffd700"
    },
    keyword: {
        color: "#00e0e0"
    },
    regex: {
        color: "#ffd700"
    },
    important: {
        color: "#ffd700",
        fontWeight: "bold"
    },
    bold: {
        fontWeight: "bold"
    },
    italic: {
        fontStyle: "italic"
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9866,3179,9774,2888,179], function() { return __webpack_exec__(8518); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);